export const CONFIG = {
  END_POINT: "https://api.tdt-resources.dev.tolber.io/api/",
  PHOTO_DEFAULT_USER: "/assets/img/users/default.jpg",
};
